<template>
    <Modal2
        v-if="visible"
        design="v3"
        class-name="bulk-department-modal"
        :show-footer="false"
        :show-title="false"
        @cancel="onCancel"
    >
        <div class="bulk-department-modal-content">
            <div class="modal-section">
                <div class="selection-wrapper">
                    <div class="section-title">
                        <i class="material-icons">business</i>
                        <span>Departman Seçimi</span>
                    </div>

                    <div class="form-field">
                        <label class="field-label">Departmanlar</label>
                        <a-select
                            v-model="selectedDepartments"
                            mode="multiple"
                            size="large"
                            placeholder="Departman seçin..."
                            :filter-option="filterOption"
                            show-search
                            class="department-select"
                        >
                            <a-select-option
                                v-for="department in availableDepartments"
                                :key="department._id"
                                :value="department._id"
                            >
                                {{ getDepartmentName(department) }}
                            </a-select-option>
                        </a-select>
                        <div class="field-hint">
                            <i class="material-icons">lightbulb_outline</i>
                            <span>Birden fazla departman seçebilirsiniz</span>
                        </div>
                    </div>
                </div>

                <div v-if="selectedDepartments.length > 0" class="preview-section">
                    <div class="preview-header">
                        <div class="header-left">
                            <i class="material-icons">apartment</i>
                            <span>Seçilen Departmanlar</span>
                        </div>
                        <div class="count-badge">{{ selectedDepartments.length }}</div>
                    </div>
                    <div class="departments-grid">
                        <div 
                            v-for="deptId in selectedDepartments" 
                            :key="deptId" 
                            class="department-card"
                        >
                            <div class="dept-icon">
                                <i class="material-icons">corporate_fare</i>
                            </div>
                            <div class="dept-info">
                                <div class="dept-name">{{ getDepartmentNameById(deptId) }}</div>
                            </div>
                            <div class="dept-check">
                                <i class="material-icons">check_circle</i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal-footer">
                <SupsisButton @click="onCancel">İptal</SupsisButton>
                <SupsisButton primary @click="onConfirm">
                    <i class="material-icons">add_business</i>
                    Departman Ekle
                </SupsisButton>
            </div>
        </div>
    </Modal2>
</template>

<script>
import Modal2 from "@/components/common/Modal2.vue";
import SupsisButton from "@/views/Pages/Settings/components/SupsisButton.vue";
import { mapState } from "vuex";

export default {
    name: "BulkAddDepartmentModal",
    components: { Modal2, SupsisButton },
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        selectedCount: {
            type: Number,
            default: 0,
        },
    },
    data: function () {
        return {
            selectedDepartments: [],
        };
    },
    computed: {
        ...mapState({
            subjects: (state) => state.subject.subjects?.data || [],
        }),
        availableDepartments: function () {
            return this.subjects.filter((dept) => !dept.isDeleted);
        },
    },
    methods: {
        getDepartmentName: function (department) {
            return (
                department.languageContent[this.$i18n.locale]?.name ||
                department.languageContent[Object.keys(department.languageContent)[0]]?.name ||
                department._id
            );
        },
        getDepartmentNameById: function (deptId) {
            const dept = this.subjects.find((d) => d._id === deptId);
            return dept ? this.getDepartmentName(dept) : deptId;
        },
        filterOption: function (input, option) {
            const dept = this.subjects.find((d) => d._id === option.key);
            if (!dept) return false;
            const name = this.getDepartmentName(dept);
            return name.toLowerCase().includes(input.toLowerCase());
        },
        onConfirm: function () {
            if (this.selectedDepartments.length === 0) {
                this.$message.warning("Lütfen en az bir departman seçiniz");
                return;
            }

            this.$emit("confirm", {
                action: "add-preferred-department",
                payload: {
                    departmentIds: this.selectedDepartments,
                },
            });
            this.reset();
        },
        onCancel: function () {
            this.$emit("cancel");
            this.reset();
        },
        reset: function () {
            this.selectedDepartments = [];
        },
    },
};
</script>

<style lang="scss">
.bulk-department-modal {
    .custom-modal-body {
        padding: 0 !important;
    }

    .bulk-department-modal-content {
        display: flex;
        flex-direction: column;
        min-height: 450px;

        .modal-section {
            flex: 1;
            padding: 28px;
            overflow-y: auto;
            max-height: calc(80vh - 200px);
        }

        .selection-wrapper {
            margin-bottom: 28px;

            .section-title {
                display: flex;
                align-items: center;
                gap: 10px;
                margin-bottom: 20px;
                padding-bottom: 12px;
                border-bottom: 2px solid #e8eaed;

                .material-icons {
                    font-size: 24px;
                    color: #22272d;
                }

                span {
                    font-size: 16px;
                    font-weight: 700;
                    color: #22272d;
                    letter-spacing: 0.3px;
                }
            }

            .form-field {
                .field-label {
                    display: block;
                    font-size: 14px;
                    font-weight: 600;
                    color: #495057;
                    margin-bottom: 10px;
                    letter-spacing: 0.3px;
                }

                .department-select {
                    width: 100%;
                }

                .field-hint {
                    display: flex;
                    align-items: center;
                    gap: 6px;
                    margin-top: 10px;
                    font-size: 13px;
                    color: #6c757d;

                    .material-icons {
                        font-size: 16px;
                    }
                }
            }
        }

        .preview-section {
            padding-top: 24px;
            border-top: 2px solid #e8eaed;

            .preview-header {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 16px;

                .header-left {
                    display: flex;
                    align-items: center;
                    gap: 10px;

                    .material-icons {
                        font-size: 22px;
                        color: #22272d;
                    }

                    span {
                        font-size: 15px;
                        font-weight: 700;
                        color: #22272d;
                        letter-spacing: 0.3px;
                    }
                }

                .count-badge {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    min-width: 32px;
                    height: 32px;
                    padding: 0 12px;
                    background: linear-gradient(135deg, #22272d 0%, #3d4451 100%);
                    color: white;
                    border-radius: 16px;
                    font-size: 14px;
                    font-weight: 700;
                    box-shadow: 0 2px 8px rgba(34, 39, 45, 0.2);
                }
            }

            .departments-grid {
                display: grid;
                grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
                gap: 12px;
            }

            .department-card {
                display: flex;
                align-items: center;
                gap: 14px;
                padding: 16px;
                background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
                border: 1.5px solid #e8eaed;
                border-radius: 12px;
                transition: all 0.3s ease;

                &:hover {
                    border-color: #22272d;
                    transform: translateY(-2px);
                    box-shadow: 0 4px 12px rgba(34, 39, 45, 0.08);
                }

                .dept-icon {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 44px;
                    height: 44px;
                    background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);
                    border-radius: 12px;
                    flex-shrink: 0;
                    box-shadow: 0 4px 12px rgba(0, 123, 255, 0.2);

                    .material-icons {
                        font-size: 22px;
                        color: white;
                    }
                }

                .dept-info {
                    flex: 1;
                    min-width: 0;

                    .dept-name {
                        font-size: 14px;
                        font-weight: 600;
                        color: #22272d;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }
                }

                .dept-check {
                    .material-icons {
                        font-size: 20px;
                        color: #28a745;
                    }
                }
            }
        }

        .modal-footer {
            display: flex;
            justify-content: flex-end;
            align-items: center;
            gap: 12px;
            padding: 20px 28px;
            border-top: 2px solid #e8eaed;

            .supsis-button {
                height: 44px;
                padding: 0 24px;
                font-size: 15px;
                border-radius: 10px;
                
                .material-icons {
                    font-size: 18px;
                }
            }
        }
    }
}
</style>
